import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromBindMiniCard from './reducers/bind-mini-card.reducer';
import { EffectsModule } from '@ngrx/effects';
import { BindMiniCardEffects } from './effects/bind-mini-card.effects';
import * as fromBindWifiCard from './reducers/bind-wifi-card.reducer';
import { BindWifiCardEffects } from './effects/bind-wifi-card.effects';
import * as fromBindDevice from './reducers/bind-device.reducer';
import { BindDeviceEffects } from './effects/bind-device.effects';
import * as fromBindEmbCard from './reducers/bind-emb-card.reducer';
import { BindEmbCardEffects } from './effects/bind-emb-card.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('bindMiniCard', fromBindMiniCard.reducer),
    EffectsModule.forFeature([BindMiniCardEffects, BindWifiCardEffects, BindDeviceEffects, BindEmbCardEffects]),
    StoreModule.forFeature('bindWifiCard', fromBindWifiCard.reducer),
    StoreModule.forFeature('bindDevice', fromBindDevice.reducer),
    StoreModule.forFeature('bindEmbCard', fromBindEmbCard.reducer),
  ]
})
export class BindDeviceModule { }
